import { render, staticRenderFns } from "./PWS03G01.vue?vue&type=template&id=65eb4e76&scoped=true"
import script from "./PWS03G01.vue?vue&type=script&lang=js"
export * from "./PWS03G01.vue?vue&type=script&lang=js"
import style0 from "./PWS03G01.vue?vue&type=style&index=0&id=65eb4e76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb4e76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65eb4e76')) {
      api.createRecord('65eb4e76', component.options)
    } else {
      api.reload('65eb4e76', component.options)
    }
    module.hot.accept("./PWS03G01.vue?vue&type=template&id=65eb4e76&scoped=true", function () {
      api.rerender('65eb4e76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pws/PWS03G01.vue"
export default component.exports